import {getReport} from "../services/request-manager";


export const getCollectReport = (idCollect, number) => {
    return getReport(idCollect, number)
}